var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: {
          name: "Práticas/praticas_obrigatorias",
          rules: { required: true }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.praticaSelecionada,
                      expression: "praticaSelecionada"
                    }
                  ],
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.praticaSelecionada },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.praticaSelecionada = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                errors[0]
                  ? _c("span", { staticClass: "error-message" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.praticasAtivas,
            callback: function($$v) {
              _vm.praticasAtivas = $$v
            },
            expression: "praticasAtivas"
          }
        },
        _vm._l(_vm.praticasList, function(pratica, index) {
          return _c(
            "el-collapse-item",
            {
              key: pratica.codigo,
              attrs: { name: pratica.codigo, disabled: !pratica.visivel }
            },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c(
                    "el-checkbox",
                    {
                      class: index > 0 ? "mt-2" : "",
                      attrs: { disabled: pratica.disabled },
                      on: {
                        change: function($event) {
                          return _vm.changeForms(pratica)
                        }
                      },
                      model: {
                        value: pratica.visivel,
                        callback: function($$v) {
                          _vm.$set(pratica, "visivel", $$v)
                        },
                        expression: "pratica.visivel"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(pratica.titulo) + "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              pratica.visivel
                ? _c(
                    "el-form",
                    { staticClass: "mt-3 mb-2" },
                    [
                      _c(pratica.componente, {
                        tag: "component",
                        attrs: {
                          observer: _vm.observer,
                          pratica:
                            _vm.cadastro.praticas[
                              "praticaSustentavel" + pratica.codigo
                            ],
                          cadastro: _vm.cadastro
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63e89884", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e89884","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/praticas.vue
// module id = null
// module chunks = 